__turbopack_context__.v({
  "root": "RangeSlider-module__lNxnlW__root",
  "separator": "RangeSlider-module__lNxnlW__separator",
  "sliderWrap": "RangeSlider-module__lNxnlW__sliderWrap",
  "value": "RangeSlider-module__lNxnlW__value",
  "values": "RangeSlider-module__lNxnlW__values",
});
